export function withFallback(target, fallback) {
  return new Proxy(fallback, {
    get(_base, key) {
      if (target && key in target) {
        const value = target[key]
        if (typeof value === 'function') {
          return value.bind(target)
        }
        return value
      }

      const fallbackValue = fallback[key]
      if (typeof fallbackValue === 'function') {
        return fallbackValue.bind(fallback)
      }
      return fallbackValue
    },
    has(_base, key) {
      return (target && key in target) || key in fallback
    },
    set(_base, key, value) {
      if (target) {
        target[key] = value
      } else {
        fallback[key] = value
      }
      return true
    },
  })
}
